export default "__VITE_ASSET__dDmAHiWW__"